import {
  AuditOutlined,
  CheckSquareOutlined,
  FileSyncOutlined,
  HomeOutlined,
  RetweetOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { ShowBadge } from "../components/badge";

export const ROUTE_LOGIN = "https://central.zetta-system.com";
// export const ROUTE_LOGIN = "https://dev-central.zetta-system.com";

export const KEY_ROUTE_MAIN = "@ROUTES/ROUTE_MAIN";
export const KEY_ROUTE_HOME = "@ROUTES/ROUTE_HOME";
export const KEY_ROUTE_DEVICE = "@ROUTES/ROUTE_DEVICE";
export const KEY_ROUTE_MANAGE_DEVICE = "@ROUTES/ROUTE_MANAGE_DEVICE";
export const KEY_ROUTE_QC_DEVICE = "@ROUTES/ROUTE_QC_DEVICE";
export const KEY_ROUTE_INVOICE_DEVICE = "@ROUTES/ROUTE_INVOICE_DEVICE";
export const KEY_ROUTE_REPAIR = "@ROUTES/ROUTE_REPAIR";
export const KEY_ROUTE_CHANGE_DEVICE = "@ROUTES/KEY_ROUTE_CHANGE_DEVICE";
export const KEY_ROUTE_RESERVATION_DEVICE =
  "@ROUTES/KEY_ROUTE_RESERVATION_DEVICE";

export const KEY_ROUTE_SPARE_DEVICE = "@ROUTES/KEY_ROUTE_SPARE_DEVICE";
export const KEY_ROUTE_UPLOAD_MODEL = "@ROUTES/KEY_ROUTE_UPLOAD_MODEL";

export const ROUTE_MAIN = {
  KEY: KEY_ROUTE_MAIN,
  PATH: "/",
  TITLE: "หน้าหลัก",
};
export const ROUTE_HOME = {
  KEY: KEY_ROUTE_HOME,
  PATH: "/home",
  TITLE: "หน้าหลัก",
  ICON: HomeOutlined,
};
export const ROUTE_DEVICE = {
  KEY: KEY_ROUTE_DEVICE,
  PATH: "/device",
  TITLE: "อุปกรณ์",
};
export const ROUTE_MANAGE_DEVICE = {
  KEY: KEY_ROUTE_MANAGE_DEVICE,
  PATH: "/manage",
  TITLE: "นำเข้าเครื่องตัด",
  ICON: UploadOutlined,
};
export const ROUTE_QC_DEVICE = {
  KEY: KEY_ROUTE_QC_DEVICE,
  PATH: "/qc",
  TITLE: "QC เครื่องตัด",
  SEARCH: "?p=",
  ICON: WarningOutlined,
};
export const ROUTE_INVOICE_DEVICE = {
  KEY: KEY_ROUTE_INVOICE_DEVICE,
  PATH: "/invoice",
  TITLE: "S/N - Invoice",
  SEARCH: "?i=",
  ICON: FileSyncOutlined,
};
export const ROUTE_REPAIR = {
  KEY: KEY_ROUTE_REPAIR,
  PATH: "/repair",
  TITLE: "ซ่อม / เคลม",
  ICON: RetweetOutlined,
};
export const ROUTE_CHANGE_DEVICE = {
  KEY: KEY_ROUTE_CHANGE_DEVICE,
  PATH: "/change",
  TITLE: "คอนเฟิร์มเคลมเครื่อง",
  ICON: CheckSquareOutlined,
  BADGE: ShowBadge,
};
export const ROUTE_RESERVATION_DEVICE = {
  KEY: KEY_ROUTE_RESERVATION_DEVICE,
  PATH: "/reservation",
  TITLE: "การจองสินค้า",
  ICON: AuditOutlined,
};
export const ROUTE_SPARE_DEVICE = {
  KEY: KEY_ROUTE_SPARE_DEVICE,
  PATH: "/spare",
  TITLE: "คอนเฟิร์มเครื่องสแปร์",
  ICON: AuditOutlined,
};
export const ROUTE_UPLOAD_MODEL = {
  KEY: KEY_ROUTE_UPLOAD_MODEL,
  PATH: "/upload-model",
  TITLE: "อัปโหลดโมเดล",
  ICON: UploadOutlined,
};

export const ROUTE_HANDLE = "/account/handle";
